import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addPaymentDetailsPopupStandardTitle: {
		id: 'navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-title',
		defaultMessage: 'Standard trial',
		description: 'Title for add payment details popup on standard plan',
	},
	addPaymentDetailsPopupPremiumTitle: {
		id: 'navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-title',
		defaultMessage: 'Premium trial',
		description: 'Title for add payment details popup on premium plan',
	},
	addPaymentDetailsPopupStandardContent: {
		id: 'navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-content',
		defaultMessage: 'To stay on the Standard plan after your trial, add your payment details.',
		description: 'Content on for add payment details popup on standard plan',
	},
	addPaymentDetailsPopupPremiumContent: {
		id: 'navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-content',
		defaultMessage: 'To stay on the Premium plan after your trial, add your payment details.',
		description: 'Content on for add payment details popup on premium plan',
	},
	addPaymentDetailsPopupButton: {
		id: 'navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-button',
		defaultMessage: 'Add payment details',
		description: 'Button to add payment details inside add payment details popup',
	},
});
